import { render, staticRenderFns } from "./proyecto-web.html?vue&type=template&id=f107a9be&scoped=true&"
import script from "./proyecto-web.ts?vue&type=script&lang=ts&"
export * from "./proyecto-web.ts?vue&type=script&lang=ts&"
import style0 from "./proyecto-web.scss?vue&type=style&index=0&id=f107a9be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f107a9be",
  null
  
)

export default component.exports